<template>
  <div class="wrapper">
    <!-- Header -->
    <header class="py-3">
      <h2 class="mb-0 text-white text-center">
        MNGHA Adult Immunization Guide
      </h2>
    </header>

    <!-- Vaccination Buttons -->
    <div class="container py-4 text-center">
      <h3 class="text-center secndary-title">The Adult Immunization Guide</h3>
      <p class="content mt-4">
        is a web-based mobile application developed by the Community and Public
        Health, Infection Prevention and Control Program at MNGHA, Riyadh, Saudi
        Arabia. This innovative tool is designed to assist healthcare providers
        in accessing the latest updates and recommendations on adult
        immunizations. By offering up-to-date, evidence-based guidelines, the
        app streamlines decision-making and supports the delivery of
        high-quality care.
      </p>
      <p class="content mt-5">
        With a user-friendly interface, the guide ensures healthcare
        professionals can quickly reference essential immunization
        recommendations, vaccine-specific information, and guidance tailored to
        adult patients, including those with special health considerations. This
        application reflects MNGHA's commitment to advancing public health
        through technology and empowering providers to protect communities from
        vaccine-preventable diseases.
      </p>
    </div>

    <!-- animated  Banner -->
    <div class="text-center mt-4 mx-2 animated-banner">
      <img
        src="@/assets/page2/Asset 8.png"
        alt="Banner"
        class="img-fluid mx-auto d-block"
      />
    </div>

    <p class="text-center secndary-title h3">
      Vaccinations care about whatever your age
    </p>

    <div class="text-center mt-5 mx-2 animated-banner">
      <img
        src="@/assets/page24/Asset 1.png"
        alt="Banner"
        class="img-fluid mx-auto d-block"
      />
    </div>
    <div class="container py-2 feedback-section text-center">
      <div class="mt-5">
        <h3 class="text-center secndary-title">We Value Your Feedback!</h3>
        <p>
          This version of the Adult Immunization Guide (v5.25.01) is a trial
          edition. We kindly request your support by sharing any observations or
          suggestions that could enhance the usefulness of this application.
          Please send your feedback to:<a href="mailto:IPC_PH@mngha.med.sa"
            >IPC_PH@mngha.med.sa</a
          >
        </p>
      </div>
    </div>
    <div class="container py-2 feedback-section text-center">
      <div class="mt-3">
        <p class="secondary-footer">
          This guide is intended for informational purposes only and does not
          constitute medical or legal advice. Vaccine recommendations may change
          based on updates from jurisdictional health authorities. Users are
          strongly advised to consult qualified healthcare professionals before
          making any medical decisions. The authors and publishers assume no
          responsibility or liability for the use or misuse of this information.
        </p>
      </div>
    </div>

    <!-- Footer Navigation -->
    <!-- <FooterNavigation
      :prevRoute="'/vaccination'"
      :nextRoute="'/vaccination'"
    /> -->
  </div>
</template>

<script setup>
// import FooterNavigation from "@/components/FooterNavigation.vue";
import { ref, onMounted } from "vue";

const isMounted = ref(false);

// Animation trigger on mount
onMounted(() => {
  isMounted.value = true;
});
</script>
<style scoped>
/* Header Styling */
header {
  background-color: #2c4fa1;
}
header h2 {
  color: white;
}

/* Footer Banner */
footer img {
  max-height: 100px;
}
.lower-panner {
  margin-bottom: 10rem;
}
ul {
  list-style: none; /* Remove default bullets */
  padding-left: 20px; /* Ensure alignment */
}

li {
  position: relative;
  padding-left: 30px; /* Space for custom bullet */
}

li::before {
  content: url("@/assets/page24/Asset 231.png"); /* Replace with your image */
  position: absolute;
  left: 0;
  top: 5px; /* Adjust for alignment */
  width: 16px; /* Set appropriate width */
  height: 16px; /* Set appropriate height */
}

.bold {
  font-weight: bold;
}
.list-content {
  font-size: 21px;
}
/* mission/vission container */
.mission-container,
.vision-container {
  display: flex;
  align-items: center;
  gap: 20px; /* Space between image and text */
}
.mission-container {
  background-color: #70c6eb;
}
.vision-container {
  background-color: #1f65b1;
  color: #ffff;
}
.left-image {
  width: 222px; /* Adjust size as needed */
  height: auto;
}

.right-text {
  font-size: 21px;
  padding: 14px;
  line-height: 1.6;
}
.principles-title {
  font-size: 21px;
  color: #1f65b1;
  background-color: #dbd9d9;
}
.principles-right-img {
  width: 200px;
}
.principles-container .list-content {
  color: #1f65b1;
}
@media (max-width: 480px) {
  .mission-container,
  .vision-container {
    display: block;
  }
  .mission-container .left-image,
  .vision-container .left-image {
    margin: auto;
    text-align: end;
    display: block;
    padding-top: 15px;
  }
  .principles-left-img {
    display: block;
    margin: auto;
  }
  .principles-right-img {
    width: 100%;
  }
}

/* new design */
.content {
  font-size: 21px;
}
.secndary-title {
  color: #1f65b1;
}
.feedback-section {
  margin-bottom: 10rem;
  font-size: 21px;
}
/* Animation for the Middle Image */
.animated-banner {
  animation: glow-fade 2s ease-in-out forwards, float 4s ease-in-out infinite;
  transform-origin: center;
}

@keyframes glow-fade {
  0% {
    opacity: 0;
    transform: scale(0.5);
    filter: blur(10px);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
    filter: blur(4px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px); /* Increased float effect */
  }
}
.secondary-footer {
  font-size: 16px;
}
</style>
